const defaultConfig = {
  titleKey: "features_title",
  itemsKey: "features_items",
  imageKey: "features_image",
};

/**
 *
 * @param page
 * @param config
 * @param props
 * @returns {{component: string, props}|null}
 */
export const features = ({ page, config, ...props }) => {
  config = Object.assign({}, defaultConfig, config);

  if (!page || !(config.itemsKey in page) || page[config.itemsKey].length === 0) {
    return null;
  }

  return {
    component: "Features",
    props: {
      title: page[config.titleKey] ?? null,
      items: page[config.itemsKey].map((i) => ({
        title: i.title ?? null,
      })),
      image: page[config.imageKey] ?? null,
      ...props,
    },
  };
};
